import { styles } from "../styles";

export default function AuditTrail({ trail, label = "Audit Trail" }) {
  const entries = trail || [];

  return (
    <div style={styles.card}>
      <strong>{label}</strong>

      {entries.length === 0 ? (
        <p>No audit history.</p>
      ) : (
        entries.map((entry) => (
          <div key={entry.id} style={{ marginTop: "8px" }}>
            <strong>{entry.action}</strong>
            <br />
            {entry.details}
            <br />
            <span style={{ fontSize: "12px", color: "#666" }}>
              {entry.user} — {entry.timestamp}
            </span>
          </div>
        ))
      )}
    </div>
  );
}
